import { render, staticRenderFns } from "./RevenuesTypeAdd.vue?vue&type=template&id=688bc7ee&"
import script from "./RevenuesTypeAdd.vue?vue&type=script&lang=js&"
export * from "./RevenuesTypeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports